import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';
import { is } from 'ramda';
import { klona } from 'klona';

// tools
import formatDateString from '../../helpers/formatDateString';

// store
import { storeSet } from '../../store';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import { cueSheetTypes } from '../../configData';

const ModalAddCueSheetItem = ({
                                  projectId,
                                  type,
                                  headerText = __('Aggiungi alla CueSheet/SoundList', 'soundbetween')
                              }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        watch,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            label: '',
            title: '',
            image: null
        }
    });

    const fileValue = watch('image');

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            if (formData.image) {
                // File import workflow: send only file
                const formDataToSend = new FormData();
                formDataToSend.append('file', formData.image);
                await storeSet('importCueSheetItems', projectId, formDataToSend);
            } else {
                // Manual entry workflow: send JSON
                let updatedFormData = klona({ ...formData });
                updatedFormData.cue_type = cueSheetTypes[type];
                updatedFormData.timecode = '00:00:00:00';
                delete updatedFormData.image;

                await storeSet('createCueSheetItem', projectId, updatedFormData);
            }

            reset();
            setModalVisible(false);
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    }

    const handleCreateNew = () => {
        setModalVisible(true);
    }

    const handleCloseModal = () => {
        reset();
        setModalVisible(false);
    }

    return (
        <>
            <ButtonFlat
                onClick={handleCreateNew}>
                {__('+ Aggiungi', 'soundbetween')}
            </ButtonFlat>
            {modalVisible
                ? <ModalDialog
                    additionalClasses={['modalCreateProject']}
                    header={headerText}
                    visible={modalVisible}
                    onSubmit={handleSubmit(onSubmit)}
                    onHide={handleCloseModal}>
                    <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                        <FormField
                            type="text"
                            name="label"
                            label={__('Label', 'soundbetween')}
                            placeholder={__('es 1m3', 'soundbetween')}
                            control={control}
                        />

                        <FormField
                            control={control}
                            name="title"
                            label={__('Titolo', 'soundbetween')}
                            placeholder="Titolo"
                            type="text"
                            rules={{
                                required: !fileValue ? __('È obbligatorio', 'soundbetween') : false
                            }}
                        />

                        <div className="appForm__heading">
                            <p>{__('Oppure Carica file', 'sounbetween')}</p>
                            <span>{__('File supportati: .csv, .xlsx', 'sounbetween')}</span>
                        </div>

                        <FormField
                            control={control}
                            name="image"
                            label={__('Oppure carica file', 'soundbetween')}
                            placeholder={__('Scegli un file', 'soundbetween')}
                            type="fileupload"
                            accept=".csv, .xlsx"
                            rules={{
                                required: false
                            }}
                        />

                        <div className="appFormActions">
                            <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                                {__('Anulla', 'soundbetween')}
                            </ButtonFlat>
                            <ButtonFormSubmit disabled={loading || !isValid}>
                                {__('Salva e continua', 'soundbetween')}
                            </ButtonFormSubmit>
                        </div>
                    </form>
                </ModalDialog> : null}
        </>
    )
}

export default ModalAddCueSheetItem;